import React from "react";

import { IgTypography, IgTypographyProps } from "./IgTypography";
import { ColorPrimary } from "./theme";

interface CopyTextProps {
  toastMessage?: (text: string) => void;
  text: string;
  customCopyText?: string;
  typographyProps?: IgTypographyProps;
}

export const IgCopyTextTypography = ({
  toastMessage,
  text,
  typographyProps,
  customCopyText,
}: CopyTextProps) => {
  const { sx, ...props } = typographyProps ?? {};
  const onCopy = async (inputText: string) => {
    await navigator.clipboard.writeText(inputText);
    if (toastMessage) {
      toastMessage(inputText);
    }
  };

  return (
    <IgTypography
      onClick={() => {
        void onCopy(customCopyText ?? text);
      }}
      sx={{
        ...sx,
        padding: "1px",
        "&:hover": {
          cursor: "pointer",
          padding: "1px",
          backgroundColor: ColorPrimary.light5,
          borderRadius: "5px",
        },
      }}
      {...props}
    >
      {text}
    </IgTypography>
  );
};
